import { pushNotification } from '@frontend/pole-ui/lib/components/Notification'
import { AxiosClient } from '@pole/client/agromarket'
import { registerAuctionsAxiosClient } from '@/api/client/auctions'
import { registerMonolithAxiosClient } from '@/api/client/axios'
import { registerDadataAxiosClient } from '@/api/client/dadata'
import { registerInputsCatalogAxiosClient } from '@/api/client/inputs-catalog'
import { registerLibCoreAgentApiAxiosClient } from '@/api/client/lib-core-agent-api'
import { registerLibCoreSignatureApiAxiosClient } from '@/api/client/lib-core-signature-api'
import { registerLibCoreTemplatesApiAxiosClient } from '@/api/client/lib-core-templates-api'
import { registerLibIfaCommunicationApiAxiosClient } from '@/api/client/lib-ifa-communication-api'
import { registerLibIntegrationDadataApiAxiosClient } from '@/api/client/lib-integration-dadata-api' // Общий хендлер для всех клиентов внутри агромаркета
import { RESPONSE_ERRORS } from '@/api/client/responseErrorConstants'
import type { TAppStore } from '@/redux/interfaces'

// Общий хендлер для всех клиентов внутри агромаркета
AxiosClient.setGlobalErrorHandler(status => {
  if (typeof window !== 'undefined') {
    if (status === 500) pushNotification({ title: RESPONSE_ERRORS['500'], status: 'error' })
    if (status === 400) pushNotification({ title: RESPONSE_ERRORS['400'], status: 'warning' })
  }
})

export const reduxStore: { store: TAppStore | undefined } = { store: undefined }

export const injectStoreToAxiosInstance = (_store: unknown) => {
  reduxStore.store = _store as TAppStore
}

export const registerApi = () => {
  registerAuctionsAxiosClient()
  registerMonolithAxiosClient()
  registerDadataAxiosClient()
  registerInputsCatalogAxiosClient()
  registerLibCoreAgentApiAxiosClient()
  registerLibCoreSignatureApiAxiosClient()
  registerLibCoreTemplatesApiAxiosClient()
  registerLibIfaCommunicationApiAxiosClient()
  registerLibIntegrationDadataApiAxiosClient()
}
